import React, { useEffect } from 'react';

const Loading = (props) => {
    const {loadOpen} = props

    //로딩 될 때 뒷배경 스크롤 방지
    useEffect(() => {
        if (loadOpen) {
            document.body.style.overflowY = 'hidden';   
        } else {
            document.body.style.overflowY = '';     
        }
        //스타일 초기화
        return () => {
            document.body.style.overflowY = ''; 
        };
    }, [loadOpen]);

    return (
        <>
            {loadOpen ? (
                <div className="loading" ></div>
            ) : (
                null //로딩중 아닐 때
            )}
        </>
    );
}
export default Loading;